import { render, staticRenderFns } from "./LogoApp.vue?vue&type=template&id=2eca502a&scoped=true&"
import script from "./LogoApp.vue?vue&type=script&lang=js&"
export * from "./LogoApp.vue?vue&type=script&lang=js&"
import style0 from "./LogoApp.vue?vue&type=style&index=0&id=2eca502a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eca502a",
  null
  
)

export default component.exports